"use client"
import { ArrowLeft } from "lucide-react"

export default function StepMarker({ currentStep, totalSteps, onBack }) {
  return (
    <div className="flex items-center mb-4">
      <button onClick={onBack} className="mr-3">
        <ArrowLeft size={18} className="text-gray-500" />
      </button>
      <div className="text-xs uppercase text-gray-500 font-medium mr-3">STEP {currentStep}</div>
      <div className="flex-1 flex space-x-1">
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            className={`h-1 flex-1 rounded-full ${index + 1 <= currentStep ? "bg-[#7B189F]" : "bg-gray-200"}`}
          />
        ))}
      </div>
    </div>
  )
}
